import styled from "styled-components";

export default styled.div`
  margin: 0 auto;
  box-shadow: 0 0 10px 0 #000;
  margin-top: 20px;
  width: 750px;
  border-radius: 3px;
  overflow: hidden;
`;
